import MealPlanPhotoPay from '@/views/MealPlanPhotoPay/index.vue'

const MealPlanPhotoPayRouter = {
  path: '/meal-plan-photo-pay',
  name: 'MealPlanPhotoPay',
  component: MealPlanPhotoPay,
  props: (route) => ({
    voucher_code: route.query.voucher_code,
    secret: route.query.secret
  })
}

export default MealPlanPhotoPayRouter
